import type { Joi } from '@ksyos/koi';

export function addAllowNull<T extends Record<keyof T, Joi.AnySchema>>(schemaObject: T, excludeKeys?: (keyof T)[]): T {
    if (typeof schemaObject !== 'object') {
        throw new Error('schemaObject should be of type object');
    }
    const newSchemaObject = { ...schemaObject };

    for (const key of Object.keys(schemaObject) as (keyof T)[]) {
        if (!excludeKeys?.includes(key)) {
            newSchemaObject[key] = newSchemaObject[key].allow(null);
        }
    }

    return newSchemaObject;
}
